import { isDev } from '@/config/env'
import { datadogRum } from '@datadog/browser-rum'

export const reportError = (error: unknown, extra?: Record<string, unknown>) => {
  if (isDev()) {
    console.error(error, extra)
    return
  }
  datadogRum.addError(error, extra)
}

export const addFeatureFlagEvaluation = (feature: string, treatment: string) => {
  datadogRum.addFeatureFlagEvaluation(feature, treatment)
}

export const addAction = (action: string, extra?: Record<string, unknown>) => {
  datadogRum.addAction(action, extra)
}
